import type { AppointmentNextTag } from '../api/Appointment';

/** Nguồn nào cũng được, miễn có `dynamic_next_tags` (lịch hẹn, lịch tư vấn, lịch thực hiện, khách hàng). */
interface HasNextTags {
    dynamic_next_tags?: AppointmentNextTag[] | null;
}

/**
 * Danh sách trạng thái mà lịch hẹn được phép chuyển sang.
 *
 * Backend tính sẵn theo ma trận chuyển trạng thái (phòng ban của người đăng nhập
 * + màn hình đang mở), nên frontend chỉ việc hiển thị, không tự lọc thêm.
 *
 * Trường cũ `next_tag` là luồng tĩnh theo `next_ids` của thẻ và sắp bị backend bỏ,
 * nên cố tình không dùng làm dự phòng: nếu `dynamic_next_tags` rỗng thì đó là
 * cấu hình ma trận đang thiếu, phải sửa ở trang Ma trận trạng thái chứ không phải
 * lặng lẽ rơi về một luồng khác.
 */
export function getNextTags(appointment?: HasNextTags | null): AppointmentNextTag[] {
    return appointment?.dynamic_next_tags ?? [];
}
